
		<span [class.button-dashed]="isActive()">
			<ng-content></ng-content>
		</span>
	